// ** Styled Components
import { StyledLink, StyledText } from "components/other/styles";

// #####################################################

const LocationLink = ({
	name,
	to,
	query,
	isBold = false,
	isLast = false,
	noWrap = false,
	onClick,
}) => {
	// #####################################################

	return (
		<StyledText mr={1} noWrap={noWrap}>
			<StyledLink
				to={{
					pathname: to,
					state: {
						notUseUserSex: false,
						closeFiltersAfterLinkClick: true,
					},
					search: query,
				}}
				bold={Boolean(isBold)}
				onClick={onClick}
			>
				{name}
			</StyledLink>
			{isLast ? null : ","}
		</StyledText>
	);
};

// #####################################################

export default LocationLink;

// #####################################################
